import React, { useEffect } from "react";
// import * as FaIcons from "react-icons/fa";
import { BiMenu, BiMoon, BiSun } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconContext } from "react-icons";
import styled from "styled-components";
import { Form, Image } from "react-bootstrap";
import { logout } from "../../features/UserProfie";
import logo from "../../images/radconnext-logo.png";
import { Badge } from "react-bootstrap";
import dummy from "../../images/person-outline.png";
import { CreateTooltip, TestImage } from "../../core/Helper";
import { BsChat } from "react-icons/bs";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import ConfirmDialogB from "./ConfirmDialogB";

import BallTriangle from "react-loading-icons/dist/esm/components/ball-triangle";
import { NotifyMessageService } from "../../model/notify-message";
import { useMemo } from "react";
import { MessageOffCanvas } from "./A01_Navbar_OffCanvas";
import { MenuOffCanvas } from "./A01_Navbar_MenuCanvas";
import { changeTheme } from "../../features/Thems";

export default function Navbar() {
  const userDetail = useSelector((state) => state.user.detail);
  const userLineProfile = useSelector((state) => state.user.lineProfile);
  const scrollTop = useSelector((state) => state.scrollTrack.value.scTop);
  const mousePosX = useSelector((state) => state.scrollTrack.mousePos.x);

  const theme = useSelector((s) => s.theme.theme);
  const [sidebar, setSidebar] = useState(true);
  const [loginTimeOut, setLoginTimeout] = useState(0);
  const [oldMouseX, setOldX] = useState(0);
  const [messageBar, setMessageBar] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [messages, setMessages] = useState([]);
  const [msgCounted, setMsgCounted] = useState(0);
  const user = useSelector((state) => state.user);
  const [foundImage, setFoundImage] = useState(false);
  const [confirm, setConfirm] = useState({ show: false, action: () => {} });
  const dispatch = useDispatch();
  const [acceptLine, setAcceptLine] = useState(false);
  const TIMEOUT = 1800;

  useEffect(() => {
    setAcceptLine(true);

    TestImage(userLineProfile[0]?.pict_url)
      .then((ret) => {
        setFoundImage(true);
      })
      .catch((err) => setFoundImage(false));
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSidebar(false);
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    //เวลาเกิน 60 นาที logout
    if (mousePosX === oldMouseX) {
      if (loginTimeOut > TIMEOUT) {
        handleLogout();
      }
    } else {
      setLoginTimeout(0);
    }

    const intervalId = setInterval(() => {
      if (loginTimeOut % 15 === 1) {
        loadNewMessageCoutner();
      }
      setLoginTimeout(loginTimeOut + 1);
      setOldX(mousePosX);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [loginTimeOut]);

  const updateLineMessager = (value) => {
    axios
      .post(
        process.env.REACT_APP_API +
          "api/notify-message/accepted-linemessage-setup",
        {
          UserInfo: userDetail,
          LineAccepted: value == true ? "y" : "n",
        },
        HttpJsonHeader,
      )
      .then((res) => {
        setAcceptLine(value);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClose = () => {
    setSidebar(false);
  };

  const handleOnlieBar = () => {
    setMessageBar(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("raduser");
    dispatch(logout());
  };

  const removeAllMessage = async () => {
    let res = await NotifyMessageService.RemoveALLUserMessage({
      UserInfo: userDetail,
    });
    setMessageBar(false);
  };
  const handleConfirm = () => {
    setConfirm({
      show: true,
      title: "ยืนยันการยกเลิกข้อความทั้งหมด",
      action: (data) => {
        if (data === true) {
          removeAllMessage();
        }
      },
    });
  };

  const loadNewMessageCoutner = async () => {
    let res = await NotifyMessageService.GetUserMessageCounted({
      UserInfo: userDetail,
    });

    if (res) {
      setMsgCounted(res.MessageCounted);
    } else {
      setMsgCounted(0);
    }
  };

  const messageCanvas = useMemo(
    () => (
      <MessageOffCanvas
        {...{
          messageBar: [messageBar, setMessageBar],
          deleting: [deleting, setDeleting],
          messages: [messages, setMessages],
          handleOnlieBar: handleOnlieBar,
          handleConfirm: handleConfirm,
          styles: styles,
        }}
      />
    ),
    [messageBar, messages],
  );

  const menuCanvas = useMemo(
    () => (
      <MenuOffCanvas
        {...{
          sidebar: [sidebar, setSidebar],
          foundImage: [foundImage, setFoundImage],
          handleClose: handleClose,
          styles: styles,
          handleLogout: handleLogout,
        }}
      />
    ),
    [sidebar],
  );

  const mainPage = useMemo(() => {
    return (
      <IconContext.Provider value={{ color: "#fff", size: "20px" }}>
        <div className="navbar">
          <Link to="#" className="menu-bars">
            <BiMenu
              style={{ color: "yellow", height: "50px", width: "50px" }}
              onMouseUp={() => setSidebar(true)}
            />
          </Link>
          <div style={{ width: "auto" }}></div>
          <LogoBox style={{ textAlign: "left", maxWidth: "200px" }}>
            <img
              src={logo}
              alt=""
              style={{ width: "170px", margin: "0 0 0 20px" }}
            />
            <div style={styles.versionBox}>
              <span style={styles.versionBoxSpan1}>Version </span>
              <span style={styles.versionBoxSpan1}>
                {process.env.REACT_APP_VERSION}
              </span>
            </div>
          </LogoBox>

          {/* Box ว่างเพื่อคั่น */}
          <SpaceBox>
            {TIMEOUT - loginTimeOut < 60 ? (
              <CountdownBox>
                <BallTriangle color="#64f013" />

                <div
                  style={{ fontSize: "20px", padding: "30px 10px 5px 10px" }}
                >
                  กำลังออกจากระบบภายใน ...
                </div>
                <div
                  style={{ fontSize: "80px", margin: "10px", color: "#0dec45" }}
                >
                  {`${TIMEOUT - loginTimeOut}`}
                </div>
                <div>กรุณาเลื่อนหรือกดปุ่มเม้าส์</div>
              </CountdownBox>
            ) : (
              ""
            )}
          </SpaceBox>

          <HSpliter />

          {CreateTooltip(
            "Mode",
            <LineSwithcBox
              onClick={() => {
                dispatch(
                  changeTheme({
                    themeName: theme.themeName !== "light" ? "light" : "dark",
                  }),
                );
              }}
            >
              {theme?.themeName === "dark" ? (
                <BiMoon style={bannerIcon} />
              ) : (
                <BiSun style={bannerIcon} />
              )}
              <LabelBoxInfo>Mode</LabelBoxInfo>
            </LineSwithcBox>,
            "bottom",
          )}

          <HSpliter />

          <LineSwithcBox>
            <Form.Check
              style={{ flex: "1" }}
              type="switch"
              checked={acceptLine}
              onChange={(e) => {
                updateLineMessager(e.target.checked);
              }}
            />
            <label
              style={{
                paddingTop: "3px",
                fontSize: "12px",
                color: "var(--fore-primary)",
              }}
            >
              Line แจ้งเตือน
            </label>
          </LineSwithcBox>

          <HSpliter />

          <div
            className="people-btn"
            onClick={() => {
              setMessageBar(true);
            }}
          >
            <Badge bg={"primary"} pill={true}>
              <BsChat style={{ color: "#e0ebde" }} />
            </Badge>

            <div style={styles.BadgeCaption}>
              การแจ้งเตือน
              {msgCounted > 0 ? (
                <div style={styles.BadgeCaptionNumber}>{msgCounted}</div>
              ) : (
                <></>
              )}
            </div>
          </div>

          <HSpliter />
          <UserDetailBox
            style={{
              flex: "initial",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <UserLineText>
              {userDetail.prefix + "" + userDetail.firstname}
            </UserLineText>
            <UserLineText style={{ color: "var(--fore-primary)" }}>
              {userDetail.stafftypename}
            </UserLineText>
            <UserLineText style={{ color: "var(--fore-primary)" }}>
              {`สาขา${userDetail.brchname}`}
            </UserLineText>
          </UserDetailBox>
          {/* IMAGE and LABEL */}
          <UserDetailBox style={styles.userDetailBoxMain}>
            <div style={styles.userDetailBoxSub}>
              <Image
                style={{
                  position: "relative",
                  top: foundImage ? "-1px" : "-12px",
                  left: foundImage ? "0px" : "-10px",
                  width: foundImage ? "60px" : "80px",
                  height: foundImage ? "60px" : "80px",
                }}
                src={userLineProfile[0]?.pict_url || dummy}
              />
            </div>
          </UserDetailBox>
        </div>
        {/* {console.log("test")} */}
        {/*  MENU */}
      </IconContext.Provider>
    );
  }, [loginTimeOut, msgCounted]);

  return (
    <>
      <TransparentBar
        onMouseOver={() => {
          // setSidebar(true);
        }}
      />

      {mainPage}
      {messageCanvas}
      {menuCanvas}

      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
    </>
  );
}

const TransparentBar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 15px;
  z-index: 5;
`;

const LogoBox = styled.div`
  flex: 1;
  color: white;
  text-align: right;
  padding-right: 5px;
  padding-left: 5px;
  padding-top: 0px;
  margin-top: 0px;
  @media only screen and (max-width: 800px) {
    display: none;
  }
`;

const UserDetailBox = styled.div`
  flex: 1;
  color: white;
  text-align: right;
  padding-right: 5px;
  padding-left: 5px;
  padding-top: 0px;
  margin-top: 0px;
  @media only screen and (max-width: 800px) {
    display: none;
  }
`;

const SpaceBox = styled.p`
  text-align: center;
  padding: 0px;
  margin: 0 0 0 20px;
  height: 100%;
  font-size: 14px;
  flex: 1;
  /* -- */
  display: inline-block;
  vertical-align: middle;
  padding-top: 30px;
`;

const UserLineText = styled.p`
  text-align: center;
  padding: 0px;
  margin: 0 0 0 20px;
  height: 20px;
  font-size: 14px;
  flex: 1;
  @media only screen and (max-width: 800px) {
    display: none;
  }
`;

const styles = {
  messageBar: {
    background: "#141414",
    width: "400px",
  },
  messageBarHeader: {
    backgroundColor: "#0b46c5",
    fontSize: "17px",
    color: "#ebf3eb",
    width: "100%",
    justifyContent: "space-between",
  },
  messagebarBody: {
    flexGrow: "1",
    display: "flex",
    flex: "1",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "space-between",
    height: "100%",
  },

  imageBoxFrame: {
    borderRadius: "50px",
    overflow: "hidden",
    width: "80px",
    height: "80px",
    margin: "10px 10px 10px 10px",
    background: "var(--bg-primary)",
    border: "2px solid #0a86f3",
  },

  userDetailBoxMain: {
    borderRadius: "10px 0px",
    maxWidth: "50px",
    height: "100%",
    marginRight: "20px",
  },

  userDetailBoxSub: {
    position: "relative",
    height: "60px",
    width: "60px",
    borderRadius: "30px 30px 30px 30px",
    top: "0px",
    left: "0px",
    overflow: "hidden",
    background: "#999191",
    border: "2px solid #0a86f3",
  },
  staffBox: {
    display: "flex",
    flex: "1",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  menuFrameCover: {
    flex: "0.5",
    margin: "20px 0 0 0",
    color: "#838181",
    display: "flex",
    justifyContent: "center",
  },
  menuFrame: {
    flex: "10",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "stretch",
    borderTop: "1px solid #726b6b", //995151
    width: "100%",
    padding: "20px 0px 10px 0px",
    // borderRadius: "10px 10px 10px 10px",
    margin: "0px 0 5px 0 ",
  },

  BadgeCaption: {
    fontSize: "12px",
    color: "var(--fore-primary)",
    marginTop: "2px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  BadgeCaptionNumber: {
    color: "#f5f1eb",
    borderRadius: "5px",
    backgroundColor: "red",
    textAlign: "center",
    width: "20px",
    padding: "0 2px 0 2px",
    marginTop: "-40px",
    marginLeft: "30px",
  },

  versionBox: {
    fontSize: "10px",
    display: "flex",
    margin: "2px 2px 2px 2px",
    width: "180px",
    // border: "1px solid yellow",
    color: "var(--fore-primary)",
    justifyContent: "center",
  },
  versionBoxSpan1: {
    margin: "1px 1px 1px 1px",
  },

  offCanvasDiv1: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "space-between",
    height: "93%",
  },
};

const LineSwithcBox = styled.div`
  cursor: pointer;
  display: flex;
  padding-top: 2px;
  width: 120px;
  flex-direction: column;
  justify-content: end;
  align-items: center;
`;

const CountdownBox = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  justify-content: center;
  align-items: center;
  height: 400px;
  width: 600px;
  top: 25vh;
  left: 25vw;
  z-index: 5000;
  color: #1b90fd;
  background-color: #121212;
  padding: 50px;
  border-radius: 10px;
  opacity: 0.8;
  transition: 0.3s ease-in;
`;

const HSpliter = styled.div`
  width: 0.1px;
  opacity: 0.7;
  height: 50px;
  background-color: var(--bg-primary);
`;

const bannerIcon = {
  // color: "var(--x-fore-banner-icon)",
  color: "var(--fore-primary)",
  marginBlock: "2px",
};

const LabelBoxInfo = styled.div`
  padding-top: 5px;
  font-size: 12px;
  color: var(--fore-primary);
`;
